<template>
  <div style="padding-top: 10px">
    <div class="triangleDiv">
      <div class="triangle" :style="triangleLeft"></div>
    </div>
    <div class="div">
      <div class="Bcol" style="width: 14%"></div>
      <div class="Gcol" style="width: 26%"></div>
      <div class="Ycol" style="width: 20%"></div>
      <div class="Rcol" style="width: 40%"></div>
    </div>
    <div class="numberList">
      <div class="numberList-item" style="margin-left: 0%">15</div>
      <div class="numberList-item" style="margin-left: 7%">18.5</div>
      <div class="numberList-item" style="margin-left: 19%">25</div>
      <div class="numberList-item" style="margin-left: 16%">30</div>
      <div class="numberList-item" style="margin-left: 15%">35</div>
      <div class="numberList-item" style="margin-left: 14%">40</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: Number,
  },
  data() {
    return {};
  },
  computed: {
    triangleLeft: function () {
      try {
        if (this.number < 0) {
          return "margin-left:0%";
        } else if (this.number > 40) {
          return "margin-left:99%";
        }

        let num = (this.number - 15) * 4;
        if (num < 0) {
          num = 0;
        } else if (num > 100) {
          num = 100;
        }
        return "margin-left:" + num + "%";
      } catch (error) {}
    },
  },
  created() {},
  methods: {},
};
</script>


<style lang="less" scoped>
.div {
  width: 315px;
  height: 8px;
  margin: 0 auto;
  margin-top: 5px;
  display: flex;
  border-radius: 8px;
  overflow: hidden;
}
.div > div {
  position: relative;
}
.Bcol {
  background: #54aefb;
  border: #54aefb;
}
.Gcol {
  background: #4bd891;
  border: #4bd891;
}
.Ycol {
  background: #fbd461;
  border: #fbd461;
}

.Rcol {
  background: #f2786d;
  border: #f2786d;
}
.triangleDiv {
  width: 303px;
  height: 10px;
  margin: 0 auto;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #4ec087;
}
.numberList {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
  display: flex;
  &-item {
    margin-top: 2px;
  }
}
</style>